import React from 'react';
import { ArrowRight, Download } from 'lucide-react';

const HeroSection: React.FC = () => {
  const handleDownloadResume = () => {
    const link = document.createElement('a');
    link.href = '/Michael Guevarra Resume.pdf';
    link.download = 'Michael Guevarra Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="bg-white/30 section-padding">
      <div className="container-max">
        <div className="text-center max-w-4xl mx-auto">
          {/* Profile Picture */}
          <div className="mb-8">
            <img
              src="/profile-pic.png"
              alt="Michael's profile picture"
              className="w-40 h-40 md:w-48 md:h-48 rounded-full object-cover border-4 border-primary-200 shadow-xl mx-auto"
            />
          </div>

          {/* Main Content */}
          <h1 className="text-4xl md:text-6xl font-bold text-secondary-900 mb-6 leading-tight">
            Hey, <span className="text-primary-600">Michael</span> here.
          </h1>
          <p className="text-xl md:text-2xl text-secondary-600 mb-8 leading-relaxed max-w-3xl mx-auto">
          An AI product leader passionate about building meaningful products that solve complex, real-world problems.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-4">
            <button 
              onClick={() => {
                const el = document.getElementById('research-section');
                if (el) {
                  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
              className="btn-primary inline-flex items-center justify-center"
            >
              View My Work
              <ArrowRight className="ml-2 h-5 w-5" />
            </button>
            <button 
              onClick={handleDownloadResume}
              className="btn-secondary inline-flex items-center justify-center"
            >
              <Download className="mr-2 h-5 w-5" />
              Download Resume
            </button>
          </div>
          {/* Skip to fun stuff link */}
          <div className="mb-12">
            <button
              type="button"
              className="text-primary-600 hover:underline text-lg font-handwritten font-thin transition-colors duration-200"
              onClick={() => {
                const el = document.getElementById('threejs-section');
                if (el) {
                  el.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
              }}
            >
              (or skip to the fun stuff)
            </button>
          </div>

          {/* Status Card */}
          <div className="bg-gradient-to-br from-primary-400 to-primary-600 rounded-2xl p-6 text-white max-w-md mx-auto">
            <div className="text-center">
              <h3 className="text-lg font-semibold mb-3">Tech Stack</h3>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <span>• Python & TensorFlow</span>
                <span>• Unity & C#</span>
                <span>• AWS & GCP</span>
                <span>• React & Node.js</span>
                <span>• Reinforcement Learning</span>
                <span>• Large Language Models</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 